import { createSlice } from '@reduxjs/toolkit';

export const divestmentLPSlice = createSlice({
    name: 'divestmentLP',
    initialState: {
        dataToAction: { divestmentDate: '', salesPrice: '', divestmentParticipation: '' }
    },
    reducers: {
        selectDivestmentLP: (state, { payload }) => {
            state.dataToAction = payload;
        },
        unSelectDivestmentLP: (state) => {
            state.dataToAction = { name: '', date: '', url: '' }
        }
    }
});

export const { selectDivestmentLP, unSelectDivestmentLP } = divestmentLPSlice.actions;